/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PostCollaborationToolItemDto = {
    templateId: string;
    type: PostCollaborationToolItemDto.type;
};

export namespace PostCollaborationToolItemDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
